import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

function Navbar() {
  const storedName = localStorage.getItem("sv_name");
  
  const handleBtnLogout = () => {
    Swal.fire({
      text: 'Confirm Logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = "/Login";
      }
    });
  };

  return(
    <>
      {/* Navbar */}
      <div className="fixed top-0 left-0 right-0 flex justify-between items-center bg-gray-700 shadow px-6 py-4 z-50">
        <div className="text-xl font-semibold text-yellow-600">
          Hi, {storedName}
        </div>
        <div
          className="text-lg text-red-600 font-semibold cursor-pointer hover:underline"
          onClick={handleBtnLogout}
        >
          Logout
        </div>
      </div>
    </>
  );
}

export default Navbar;